<div
  class="annotation-color-menu"
  [ngClass]="{'isDialog': isDialog}"
>
  <div class="medium-12 columns annotation-color-menu__button-container">
    <mat-form-field
      appearance="fill"
      class="annotation-color-menu__select"
    >
      <span
        matPrefix
        class="annotation-color-menu__colorBox"
        [ngStyle]="{'background-color': curAnn.state.edit ? curAnn.currentColor : '#666'}"
      ></span>

      <mat-select
        [disabled]="!curAnn.state.edit"
        [matTooltip]="'TRANS__ANNOTATE_MENU__DISABLED_TOOLTIP' | translate"
        [matTooltipDisabled]="curAnn.state.edit"
      >
        @for (col of curAnn.colors; track $index) {
          <mat-option
            (click)="curAnn.setColor(col)"
            (keydown)="null"
            [ngStyle]="{'background-color': col}"
          ></mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="medium-12 columns annotation-color-menu__text-container">
    <span class="annotation-color-menu__text">
      {{ 'TRANS__ANNOTATE_MENU__COLOR' | translate }}
    </span>
  </div>
</div>
